"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Confirmation = function (_BaseClass) {
    _inherits(Confirmation, _BaseClass);

    /**
     * Name des Nachweises
     * @type {string}
     */


    /**
     * Muss ein Datum von angegeben werden?
     * @type {boolean}
     */


    /**
     * Muss ein Datum bis angeben werden?
     * @type {boolean}
     */


    /**
     * Muss eine Ausweisnummer angegeben werden?
     * @type {boolean}
     */


    /**
     * Ist der Nachweis ein CouponCode?
     * @type {boolean}
     */


    /**
     * Ident des Nachweises
     * @type {string}
     */
    function Confirmation() {
        _classCallCheck(this, Confirmation);

        var _this = _possibleConstructorReturn(this, (Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).call(this));

        _this.Name = "";
        _this.DateFrom = false;
        _this.DateTo = false;
        _this.IdentificationNumber = false;
        _this.CouponCode = false;
        _this.Ident = "";
        _this.Description = "";
        return _this;
    }

    /**
     * Beschreibung des Nachweises
     * @type {string}
     */


    return Confirmation;
}(_BaseClass3.default);

exports.default = Confirmation;